import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppLocalStorage } from 'app/app-storage-manager/local-storage';
import { MiscService } from 'app/shared/misc.service';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, exhaustMap, tap } from 'rxjs/operators';
import * as dashboardActions from 'app/modules/dashboard/_state/dashboard.actions';
import { DashboardService } from '../_services/dashboard.service';
import { BroadcastService } from '../broadcast/broadcast.service';
import { JobService } from '../job-portal/job.service';
import { ManagementService } from '../management/management.service';

@Injectable({
	providedIn: 'root',
})
export class DashboardEffects {
	constructor(
		private actions$: Actions,
		private storageManager: AppLocalStorage,
		private broadcastService: BroadcastService,
		private jobService:JobService,
		private managementService: ManagementService,
		private dashboardService:DashboardService,
		private toastr: ToastrService,
		private miscService: MiscService,
		private router: Router
	) {}

	fetchPermisions$ = createEffect(() =>
		this.actions$.pipe(
			ofType(dashboardActions.fetchPermissions),
			exhaustMap((action) =>
				this.dashboardService.fetchPermissions().pipe(
					exhaustMap((response: any) => [
						dashboardActions.fetchPermissionsSuccessful({
							permissions: response.data,
						}),
					]),
					catchError((error: HttpErrorResponse) => {
						this.toastr.error(
							error?.error?.errors,
							'An error occured'
						);
						return of(dashboardActions.fetchPermissionsFailed());
					})
				)
			)
		)
	);

	fetchBroadcasts$ = createEffect(() =>
		this.actions$.pipe(
			ofType(dashboardActions.fetchBroadcasts),
			exhaustMap((action) =>
				this.broadcastService.fetchBroadcast(action.payload.currentPage,action.payload.pageSize).pipe(
					exhaustMap((response: any) => [
						dashboardActions.fetchBroadcastsSuccessful({
							broadcasts: response,
						}),
					]),
					catchError((error: HttpErrorResponse) => {
						this.toastr.error(
							error?.error?.errors,
							'An error occured'
						);
						return of(dashboardActions.fetchBroadcastsFailed());
					})
				)
			)
		)
	);

	createBroadcasts$ = createEffect(() =>
		this.actions$.pipe(
			ofType(dashboardActions.createBroadcast),
			exhaustMap((action) =>
				this.broadcastService.createBroadcast(action.payload).pipe(
					exhaustMap((response: any) => [
						dashboardActions.createBroadcastSuccessful(),
					]),
					catchError((error: HttpErrorResponse) => {
						this.toastr.error(error?.error?.message || 'Network error');
						return of(dashboardActions.createBroadcastFailed({message: error?.error?.message, code: error.status}))
					})
				)
			)
		)
	);

	fetchPastors$ = createEffect(() =>
		this.actions$.pipe(
			ofType(dashboardActions.fetchPastors),
			exhaustMap((action) =>
				this.managementService.fetchPastors(action.payload.currentPage,action.payload.pageSize, action.payload?.isVerified).pipe(
					exhaustMap((response: any) => [
						dashboardActions.fetchPastorsSuccessful({
							pastors: response,
						}),
					]),
					catchError((error: HttpErrorResponse) => {
						this.toastr.error(
							error?.error?.errors,
							'An error occured'
						);
						return of(dashboardActions.fetchPastorsFailed());
					})
				)
			)
		)
	);

	createPastor$ = createEffect(() =>
		this.actions$.pipe(
			ofType(dashboardActions.createPastor),
			exhaustMap((action) =>
				this.managementService.createPastor(action.payload).pipe(
					exhaustMap((response: any) => [
						dashboardActions.createPastorSuccessful(),
					]),
					catchError((error: HttpErrorResponse) => {
						this.toastr.error(error?.error?.message || 'Network error');
						return of(dashboardActions.createPastorFailed({message: error?.error?.message, code: error.status}))
					})
				)
			)
		)
	);

	fetchJobs$ = createEffect(() =>
	this.actions$.pipe(
		ofType(dashboardActions.fetchJobs),
		exhaustMap((action) =>
			this.jobService.fetchJobs(
				action.payload?.currentPage,
				action.payload?.pageSize,
				 action.payload?.approved,
				 action.payload?.search,
				 action.payload?.jobType,
				 action.payload?.employmentType
				).pipe(
				exhaustMap((response: any) => [
					dashboardActions.fetchJobsSuccessful({
						jobs: response,
					}),
				]),
				catchError((error: HttpErrorResponse) => {
					this.toastr.error(
						error?.error?.errors,
						'An error occured'
					);
					return of(dashboardActions.fetchJobsFailed());
				})
			)
		)
	)
);
}
